import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface InvoiceFilterState {
  hideErrorInvoices: boolean;
  setHideErrorInvoices: (value: boolean) => void;
  toggleHideErrorInvoices: () => void;
}

export const useInvoiceFilterStore = create<InvoiceFilterState>()(
  persist(
    (set) => ({
      hideErrorInvoices: false,
      setHideErrorInvoices: (value: boolean) => set({ hideErrorInvoices: value }),
      toggleHideErrorInvoices: () => set((state) => ({ hideErrorInvoices: !state.hideErrorInvoices })),
    }),
    {
      name: 'invoice-filter-storage', // Key in localStorage
    }
  )
);

/**
 * Helper function to filter invoices based on the global hideErrorInvoices setting
 * Use this in any component that displays invoices
 */
export function filterErrorInvoices<T extends { eInvoiceStatus?: number; status?: string }>(
  invoices: T[],
  hideErrors: boolean
): T[] {
  if (!hideErrors) return invoices;
  return invoices.filter((invoice) => {
    // Hide invoices with eInvoiceStatus === 1 (Error) or status === 'Error'
    const hasError = invoice.eInvoiceStatus === 1 || invoice.status === 'Error';
    return !hasError;
  });
}
